var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.66675,
    y: 4.66666,
    width: 12,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 0C18.1102 0 23.3333 5.22317 23.3333 11.6667C23.3333 18.1102 18.1102 23.3333 11.6667 23.3333C5.22317 23.3333 0 18.1102 0 11.6667C0 5.22317 5.22317 0 11.6667 0ZM9.19217 7.54133C8.9827 7.32987 8.70034 7.20646 8.40286 7.19637C8.10539 7.18628 7.81531 7.29026 7.59199 7.48704C7.36867 7.68382 7.22901 7.95852 7.2016 8.2549C7.17418 8.55128 7.26107 8.84693 7.4445 9.08133L7.5425 9.19217L10.0158 11.6655L7.5425 14.1412C7.33104 14.3506 7.20763 14.633 7.19754 14.9305C7.18744 15.2279 7.29143 15.518 7.48821 15.7413C7.68499 15.9647 7.95968 16.1043 8.25606 16.1317C8.55244 16.1592 8.84809 16.0723 9.0825 15.8888L9.19217 15.792L11.6667 13.3163L14.1412 15.792C14.3506 16.0035 14.633 16.1269 14.9305 16.137C15.2279 16.1471 15.518 16.0431 15.7413 15.8463C15.9647 15.6495 16.1043 15.3748 16.1317 15.0784C16.1592 14.7821 16.0723 14.4864 15.8888 14.252L15.792 14.1412L13.3163 11.6667L15.792 9.19217C16.0035 8.9827 16.1269 8.70034 16.137 8.40286C16.1471 8.10539 16.0431 7.81531 15.8463 7.59199C15.6495 7.36867 15.3748 7.22901 15.0784 7.2016C14.7821 7.17418 14.4864 7.26107 14.252 7.4445L14.1412 7.54133L11.6667 10.017L9.19217 7.54133Z",
    fill: "#302D1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.63ee2af26bbb6813472b309efafda8f8.svg";
export { ForwardRef as ReactComponent };